<template>
    <div>
        <div class="box"></div>
        <div class="box2">
            <div class="lef">
                <div>智慧工地</div>
                <p v-for="item in menuList" :key="item.id">
                    <a :class="item.id==code? 'don':''" @click="menuClick(item.id)">· {{item.title}}</a>
                </p>
            </div>
            <div v-if="dataList" class="rit">
                <p class="tit">{{dataList.title}}</p>
                <div v-if="dataList.id===4" class="img"><img :src="dataList.img" style="width:3.41rem"></div>
                <div v-else-if="dataList.id===5" class="img"><img :src="dataList.img" style="width:4.03rem"></div>
                <div v-else class="img"><img :src="dataList.img"></div>
                <div v-if="dataList.id===1||dataList.id===3||dataList.id===6||dataList.id===8||dataList.id===9" class="img" style="margin-top:.2rem"><img :src="dataList.img2"></div>
                <div class="txt">{{dataList.text}}</div>
                <div class="but">
                    <span class="l" @click="upClick(dataList.id)">上一篇</span>
                    <span class="r" @click="nextClick(dataList.id)">下一篇</span>
                </div>
            </div>
            <div v-else class="prop">暂时没有内容~</div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "NewsCeter",
        data(){
            return{
                code:sessionStorage.getItem('applyCode'),
                dataList:{},
                menuList:[
                    {
                        id:1,
                        title:'佛山万科金融中心广场',
                        img:require('../../assets/images/apply/site/al1.jpg'),
                        img2:require('../../assets/images/apply/site/al1b.jpg'),
                        text:'广东佛山万科广场三期项目项目总占地面积13.5万平方米，由1栋35层、1栋39层总部型商务办公楼、1栋46层高端公寓、国际酒店等复合业态为一体的奢华城市综合体组成，总建筑面积32万平方米，最大建筑高度172.5米。'
                    },{
                        id:2,
                        title:'长沙京武浪琴山三期',
                        img:require('../../assets/images/apply/site/al2.jpg'),
                        text:'沙市雨花区劳动东路与古曲南路交汇处东南角工程阶段:主体施工/主体施工开工工程造价:300百万建筑面积：91186m2(办公楼建筑)12538m2(商业及零售建筑)10258m2(交通建筑)钢结构：框架结构剪力墙结构。'
                    },{
                        id:3,
                        title:'东莞万科东江之星',
                        img:require('../../assets/images/scheme/site/gd5.jpg'),
                        img2:require('../../assets/images/scheme/site/gd6.jpg'),
                        text:'东江之星商业中心项目建筑高度149.7m，总建筑面积38万㎡，总占地面积6万㎡，容积率7.48，绿化率24%，建成后将是集商业、住宅、高层写字楼为一体的现代化综合体，将打造为东莞新的地标性建筑。项目承办了2018年全国建设工程项目施工安全生产标准化工地等多次现场观摩交流活动。'
                    },{
                        id:4,
                        title:'华邦国际中心',
                        img:require('../../assets/images/apply/site/al4.jpg'),
                        text:'该项目位于广州市海珠区核心创新区琶洲西区，总建筑面积约13.6万平米，共有2栋塔楼，4层地下室，A栋塔楼共有36层，高172.5米，B栋塔楼共有34层，高149.5米，两栋塔楼在高135.5米处通过钢结构空中城市看台相连接，此连廊将成为广州世界级天际线及滨水长廊。项目建成后将成为华邦控股集团全球总部大厦，为广东省重点打造的世界级创新区。'
                    },{
                        id:5,
                        title:'前海冠泽金融中心项目',
                        img:require('../../assets/images/apply/site/al5.jpg'),
                        text:'前海冠泽金融中心位于中国深圳前海自贸区，是一个总体为108218.67万平方米的商业综合体，此商业综合体由两栋甲级办公楼，一栋五星级酒店和两栋商业办公塔楼以及两栋服务式公寓塔楼组成。'
                    },{
                        id:6,
                        title:'南沙医院',
                        img:require('../../assets/images/apply/site/al6.jpg'),
                        img2:require('../../assets/images/apply/site/al6b.jpg'),
                        text:'本项目为南沙区政府与中山一院在南沙合作建设的高水平三级甲等医院，含医疗、科研、教学、宿舍等功能，占地面积155934㎡，建筑面积506304㎡，计容面积33万㎡，建筑高度117m，建成后将提供1500张床位，计划总投资额约为45.2亿元人民币。'
                    },{
                        id:7,
                        title:'深湾汇云中心',
                        img:require('../../assets/images/apply/site/al7.jpg'),
                        text:'项目以居住、商业、办公为主要导向，配套设施完善，是兼具休闲及交通等功能的大型城市综合体。总用地面积68285.89㎡，总建筑面积470000㎡，共9栋塔楼，最高塔楼356.5m，总投资额50亿元。'
                    },{
                        id:8,
                        title:'碧桂园',
                        img:require('../../assets/images/scheme/site/gd3.jpg'),
                        img2:require('../../assets/images/scheme/site/gd4.jpg'),
                        text:'本项目采用垂直绿化生态方案，并设计配备了智能化出入口管理系统、网络信息系统和电子会议系统配备，主要建设办公楼、公寓楼、专家楼、地下室，并配备了图书馆、电影院、恒温泳池、康乐健身室等设施；总建筑面积：131624.05㎡，用地面积：96952.51㎡，地上层数：22层，地下层数：3层，计容建筑面积：89289.82㎡，预计总投资额为13.13亿元人民币。'
                    },{
                        id:9,
                        title:'武汉京东方',
                        img:require('../../assets/images/scheme/site/gd1.jpg'),
                        img2:require('../../assets/images/scheme/site/gd2.jpg'),
                        text:'本项目是全球最大的“中国屏”厂房、京东方布局的第二条10.5代线，是武汉迄今最大、最高标准的电子洁净厂房。占地面积88.30万㎡，建筑面积76万㎡，建筑高度44.03m，总投资460亿元。承办了2018全国绿色·智慧建造技术交流会暨武汉京东方10.5代线项目现场观摩会。'
                    },{
                        id:10,
                        title:'深圳恒大中心',
                        img:require('../../assets/images/apply/site/al10.jpg'),
                    },{
                        id:11,
                        title:'深圳前海嘉里广场项目',
                        img:require('../../assets/images/apply/site/al11.jpg'),
                        text:''
                    },{
                        id:12,
                        title:'深圳紫元元大厦项目',
                        img:require('../../assets/images/apply/site/al12.jpg'),
                        text:''
                    }
                ]
            }
        },
        methods:{
            menuClick(id){
                if(this.code!==id){
                    this.code=id;
                    this.dataList=this.menuList[this.code-1];
                    sessionStorage.setItem('applyCode',id);
                }
            },
            upClick(id){
                if(id!==1){
                    this.code=id-1;
                    this.dataList=this.menuList[this.code-1];
                    sessionStorage.setItem('applyCode',id-1);
                    document.documentElement.scrollTop=0;
                }

            },
            nextClick(id){
                let count=this.menuList.length;
                if(id!==count){
                    this.code=id+1;
                    this.dataList=this.menuList[this.code-1];
                    sessionStorage.setItem('applyCode',id+1);
                    document.documentElement.scrollTop=0;
                }
            }
        },
        mounted(){
            this.dataList=this.menuList[this.code-1];
            document.documentElement.scrollTop=0;
        }
    }
</script>

<style lang="scss" scoped>
    .box{
        height: 2.9rem;
        width: 100%;
        background: url("../../assets/images/zh.jpg");
        background-size: 100% 100%;
    }
    .box2{
        width: 12rem;
        margin:.6rem auto 0;
        display: flex;
        .lef{
            width: 1.76rem;
            overflow: hidden;
            div{
                font-size: .2rem;
                position: relative;
                padding-left: .1rem;
                margin-bottom:.19rem;
            }
            div::before{
                position: absolute;
                content: "";
                left:0rem;
                top:.06rem;
                background: #E70F20;
                width: 2px;
                height: .16rem;
            }
            p{
                line-height: .34rem;
                font-size: .16rem;
                width: 1.76rem;
                color:#3F3F3F;
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
                cursor:pointer;
                a{
                    display: inline-block;
                    width: 100%;
                }
            }
            .don{
                color:#E70F20
            }
        }
        .rit{
            margin-left: .15rem;
            border-left: 1px solid #E5E5E5;
            padding-left:.85rem;
            width: 10.07rem;
            p.tit{
                width: 5.7rem;
                font-size: .26rem;
                text-align: center;
                margin: 0 auto;
                line-height: .41rem;
                letter-spacing: 1px;
            }
            div.img{
                text-align: center;
                margin-top:.58rem;
                img{
                    width: 7rem;
                    height: 3.94rem;
                }
            }
            div.txt{
                margin-top:.44rem;
                line-height: .36rem;
                color:#595757;
                font-size: .18rem;
                text-align: justify;
            }
            div.but{
                text-align: center;
                margin-top:.56rem;
                span{
                    width: 69px;
                    height: 26px;
                    line-height: 29px;
                    display: inline-block;
                    font-size: 12px;
                    margin:0 .25rem;
                    cursor: pointer;
                }
                .l{
                    background: url("../../assets/images/pg.png");
                    background-size: 100% 100%;
                    padding-left:.07rem
                }
                .r{
                    background: url("../../assets/images/pg2.png");
                    background-size: 100% 100%;
                    padding-right:.07rem
                }
            }
        }
        .prop{
            width: 10rem;
            font-size: .26rem;
            color:#ddd;
            text-align: center;
            padding-top:1rem;
        }
    }
</style>